<template>
  <div class="profiletable mt-20 pt-40 mb-20" v-if="groupedSources && groupedSources.length > 0" id="sourceLinksSection">
    <div class="profiletable__row flex w-full">
      <div class="profiletable__row__data flex-auto w-full bg--gray-lightest flex items-center">
        Links
      </div>
    </div>
    <div class="profiletable__row flex w-full" v-for="(group, i) of groupedSources" :key="i">
      <div class="profiletable__row__data profiletable__row__data--sm flex-auto max-w-150 min-w-150 bg--gray-lightest flex justify-center items-center">
        <div class="text-center" v-if="group.icon">
          <img class="max-w-full w-auto h-3" v-if="group.icon" :src="group.icon" :alt="group.title">
          <div>
            <strong>{{ group.title }}</strong>
          </div>
        </div>
      </div>
      <div class="profiletable__row__data profiletable__row__data--sm flex-auto w-full bg--gray-200 overflow-hidden">
        <div v-for="(link, li) of group.links" :key="li" :ref="'source-' + link.source_id" class="truncate">
          {{ link.source_id }}.&nbsp;<a target="_blank" :href="link.url">{{ link.url }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {EventBus} from '@/event-bus.js'

export default {
  'name': 'source-links-section',
  props: ['sourceLinks'],
  mounted () {
    EventBus.$on('source:click', (source) => {
      this.sourceClicked(source)
    })
  },
  computed: {
    groupedSources () {
      let groups = []

      _.each(this.sourceLinks, (link) => {
        if (
          groups[groups.length - 1] &&
          !groups[groups.length - 1].icon &&
          !link.icon
        ) {
          groups[groups.length - 1].links.push(link)
        } else {
          groups.push({
            title: link.title,
            icon: link.icon,
            links: [link]
          })
        }
      })
      return groups
    }
  },
  methods: {
    sourceClicked (source) {
      let sourceId = source.source_id
      let el = this.$refs['source-' + sourceId][0]
      this.resetHighlights()
      if (this.$refs['source-' + sourceId] && el) {
        this.highlight(el)
        this.$refs['source-' + sourceId][0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    },
    resetHighlights () {
      _.each(this.sourceLinks, (source) => {
        let sourceId = source.source_id
        if (this.$refs['source-' + sourceId] && this.$refs['source-' + sourceId][0]) {
          this.deactivateHighlight(this.$refs['source-' + sourceId][0])
        }
      })
    },
    deactivateHighlight ($ref) {
      $ref.classList.remove('isHighlighted')
    },
    highlight ($ref) {
      $ref.classList.add('isHighlighted')
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/covid19/SourceLinksSection.vue